import React from "react";

export default function ML_Scatter_Plots() {
  return (
    <div>
      <h1>ML_Scatter_Plots</h1>
      <p>This is the ML_Scatter_Plots component.</p>
    </div>
  );
}
